<template>
    <div class="edit-option-wrapper">
        <edit-property-header-block action-label="Edit Option" :property-label="optionData.name">
            <version-selector @versionSelectionChange="handleVersionSelectionChange"  @availableSelections="handleAvailableVersions" class="m-0" :show-label="false"></version-selector>
            <button v-if="canDeleteOption" class="btn btn-danger" id="delete_option" style="margin-left:10px;" type="submit">Delete Option</button>
        </edit-property-header-block>
        <div class="card panel panel-default actions">
            <div class="card-block">
                <!-- <div class="version-selection-block">
                    <h3 class="card-title">Edit Option<span class="font-weight-normal" v-if="optionData.name != ''">: {{optionData.name}}</span></h3>
                    <version-selector class="pb-2" @versionSelectionChange="handleVersionSelectionChange" @availableSelections="handleAvailableVersions"></version-selector>
                </div> -->
                <div class="ks-tabs-container ks-tabs-default ks-tabs-no-separator">
                    <ul class="nav ks-nav-tabs">
                        <li><a href="#" class="nav-link" :class="{active: currentNav=='general' }" @click="navBarChange('general')">General</a></li>
                        <li><a href="#" class="nav-link" :class="{active: currentNav=='values' }" @click="navBarChange('values')">Values</a></li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane" :class="{active: currentNav=='general' }">
                            <general :version-selected="versionSelected"
                                    :show-loading="showValueLoadIndicator"
                                    :option-data="optionData"
                                    @lock-form-toggle="handleLockForm"
                                    @refresh-option-data="loadOptionData">
                            </general>
                        </div>
                        <div class="tab-pane" :class="{active: currentNav=='values' }">
                            <values :version-selected="versionSelected"
                                    :option-id="optionId"
                                    :master-option-values="masterOptionValues"
                                    :show-loading="showValueLoadIndicator"
                                    :is-filtered="isFiltered"
                                    :column-header="columnHeader"
                                    :reference-column-header="referenceColumnHeader"
                                    @lock-form-toggle="handleLockForm"
                                    @query-change="handleQueryChange"
                                    @refresh-options="loadMasterOptionValues">
                            </values>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

import VersionSelector from '../generic/version-selector.vue';
import General from './general.vue';
import Values from './values.vue';
import EditPropertyHeaderBlock from '../generic/edit-property-header-block.vue';

var base_url = window.location.protocol + "//" + window.location.host

export default {
    name: 'edit-options',
    components: {
        'version-selector': VersionSelector,
        'general': General,
        'values': Values,
        'edit-property-header-block': EditPropertyHeaderBlock,
    },
    props: {
        optionId: String,
        canDeleteOption: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            availableVersions: [],
            watchPaginationChanges: true,
            currentNav: 'general',
            versionSelected: "0",
            optionData: {
                name: '',
                displayName: '',
                type: '',
                id: 0,
            },
            searchQuery: '',
            masterOptionValues: {},
            versionOptionValues: {},
            showValueLoadIndicator: false,
            showGeneralLoadIndicator: false,
            isLoadingValues: false,
            isLoadingOptionData: false,
        }
    },
    mounted() {
        this.loadOptionData();
        this.loadMasterOptionValues(false);

        this.$events.$on('filter-set', this.handleQueryChange);

    },
    watch: {
        currentPaginationPage() {
            if (this.watchPaginationChanges) {
                this.loadMasterOptionValues(false);
            }
        }
    },
    computed: {
        currentPaginationPage() {
            if (this.masterOptionValues.hasOwnProperty('meta')) {
                return this.masterOptionValues.meta.current_page;
            }
            return 1;
        },
        isFiltered() {
            return (this.searchQuery != '');
        },
        referenceColumnHeader() {
            if (this.availableVersions.length > 0) {

                //return MASTER
                return this.availableVersions[0].name;
            }

            return '';
        },
        columnHeader() {
            if (this.availableVersions.length > 0) {

                //return select Version
                let selected = this.availableVersions.filter(item => {
                    return item.id + '' == this.versionSelected;
                });
                if (selected.length > 0) {
                    return selected[0].name;
                }
            }
            return '';
        }
    },
    methods: {
        handleAvailableVersions(values) {
            this.availableVersions = values;
        },
        handleVersionSelectionChange(value) {
            this.versionSelected = value;
            this.loadOptionData();
        },
        handleLockForm(value) {
            this.showValueLoadIndicator = value;
        },
        handleQueryChange(value) {
            this.searchQuery = value;
            this.loadMasterOptionValues(false);
        },
        navBarChange(id) {
            this.currentNav = id;
        },
        loadOptionData() {
            this.showGeneralLoadIndicator = true;
            axios.get(base_url + '/pimapi/options/'+this.optionId+'/version/' + this.versionSelected, {})
            .then((response) => {
                this.optionData = response.data.data;
                this.showGeneralLoadIndicator = false;
            })
            .catch((error) => {
                console.log('option data load ERROR!');
            });
        },
        loadMasterOptionValues(navigateToLastPage) {
            this.showValueLoadIndicator = true;
            let currentPage = this.currentPaginationPage;

            axios.get(base_url + '/pimapi/options/'+this.optionId+'/version/' + this.versionSelected + '/values?page='+currentPage+'&query='+encodeURIComponent(this.searchQuery), {})
            .then((response) => {
                let meta = response.data.meta;
                this.showValueLoadIndicator = false;

                if (meta.current_page < 1) {
                    console.log('current page less then 1 ... trying to fix');
                    this.masterOptionValues.meta.current_page = 1;
                    this.loadMasterOptionValues(false);
                }

                if (meta.current_page > meta.last_page) {
                    console.log('current page greater the last page ... trying to fix.');
                    this.masterOptionValues.meta.current_page = meta.last_page;
                    this.loadMasterOptionValues(false);
                }

                if (navigateToLastPage) {
                    //check to see that we are in fact on the last page.
                    if (meta.current_page < meta.last_page) {
                        this.watchPaginationChanges = false;
                        this.masterOptionValues.meta.current_page = meta.last_page;
                        this.loadMasterOptionValues(true);
                    }
                }

                this.watchPaginationChanges = false;
                response.data.meta = meta;

                this.masterOptionValues = response.data;
                this.$nextTick(() => {
                    this.watchPaginationChanges = true;
                });
            })
            .catch((error) => {
                console.log('option value load ERROR!');
                console.log(error);
                this.showValueLoadIndicator = false;
                this.watchPaginationChanges = true;
            });
        }
    }
};
</script>

<style>

.load-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    font-size: 1.5em;

}

.version-selection-block {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
</style>